// HomeAdmin.js
import React, { useEffect, useState } from 'react'
import { AdminDashboard, EventDashboardApi, MessDashboard, StudentMessTodaysMenuFindall } from '../ApiFile'
import Sidebar from './sidebar'
import NavLogo from './NavLogo'
import { FaUserLarge } from 'react-icons/fa6'
import { MdFreeBreakfast, MdOutlineCurrencyRupee, MdOutlinePendingActions } from 'react-icons/md'
import { RiPagesLine, RiTodoFill } from 'react-icons/ri'
import { PiStudentFill } from 'react-icons/pi'
import { AiFillAppstore, AiFillCarryOut, AiFillContainer } from 'react-icons/ai'
import { Link } from 'react-router-dom'
import { Button } from '@mui/material'
import { FaUserCircle } from 'react-icons/fa'
import { MdBedroomChild } from 'react-icons/md'
import { TbCoinRupeeFilled } from 'react-icons/tb'
import { FaHourglassHalf } from 'react-icons/fa'
import { MdHourglassFull } from 'react-icons/md'
import { MdEvent } from 'react-icons/md'
import axios from 'axios'
import { Pie } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Col, Row } from 'react-bootstrap'
import MobileNavbarAdmin from './pages/MobileNavbarAdmin'

const HomeAdmin = () => {
  const [dashboardData, setDashboardData] = useState(null)
  const [messDashboardData, setMessDashboardData] = useState(null)
  const [events, setEvents] = useState([])
  const [lunchData, setLunchData] = useState(null)
   const [dinnerData, setDinnerData] = useState(null)
  const [error, setError] = useState(null)
  const [error1, setError1] = useState(null)
  const sessionYears = sessionStorage.getItem('selectedYear')
  const adminFlag = sessionStorage.getItem('flag')

  useEffect(() => {
    //---------------------------------Disabled back button-------------------------------
    window.history.pushState(null, null, window.location.href)

    const handleBackButton = (event) => {
      event.preventDefault()
      window.history.forward()
    }

    window.addEventListener('popstate', handleBackButton)

    return () => {
      window.removeEventListener('popstate', handleBackButton)
    }
  }, [])

  // ===All(Main, Superintendent, Office) Admin Dashboard Data=========
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await fetch(AdminDashboard, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ year: sessionYears }), // Pass the year in the request body
        })
        if (!response.ok) {
          throw new Error('Failed to fetch dashboard data')
        }
        const data = await response.json()
        setDashboardData(data)
      } catch (error) {
        // console.error('Failed to fetch dashboard data', error);
      }
    }

    fetchDashboardData()
  }, [])

  // ===Mess Dashboard Data=========
    useEffect(() => {
    const fetchMessDashboardData = async () => {
      try {
        const response = await axios.get(MessDashboard)
        if (response.data !== null) {
          setMessDashboardData(response.data)
        }
        
      } catch (error) {
        console.error('Failed to fetch mess dashboard data', error);
      }
    }

    fetchMessDashboardData()
  }, [])

  useEffect(() => {
    fetch(EventDashboardApi)
      .then((response) => {
        if (!response.ok) {
          throw new Error('NOTFOUND')
        }
        return response.json()
      })
      .then((data) => {
        setEvents(data)
      })
      .catch((error) => {
        if (error.message === 'NOTFOUND') {
          setError('Resource not found')
        } else {
          setError('Add Event')
        }
      })
  }, [EventDashboardApi])

useEffect(() => {
    // Fetch the today's menu data from the API
    fetch(StudentMessTodaysMenuFindall)
      .then((response) => response.json())
      .then((data) => {
        // Update the lunch data
        setLunchData({
          labels: data.lunch.map((item) => item.menu),
          datasets: [
            {
              data: data.lunch.map(() => 15), // Example data values, modify as needed
              backgroundColor: [
                '#FF6384',
                '#36A2EB',
                '#FFCE56',
                '#4BC0C0',
                '#9966FF',
                '#FF9F40',
                '#FFCD56',
              ],
              color:"black",
            },
          ],
        })

        // Update the dinner data
        setDinnerData({
          labels: data.dinner.map((item) => item.menu),
          datasets: [
            {
              data: data.dinner.map(() => 20), // Example data values, modify as needed
              backgroundColor: [
                '#FF6384',
                '#36A2EB',
                '#FFCE56',
                '#4BC0C0',
                '#9966FF',
                '#FF9F40',
              ],
              color:"black",
            },
          ],
        })
      })
      .catch((error) => {
        console.error('Error fetching the menu data:', error)
      })
  }, [])

    // Chart options with datalabels plugin
  const options = {
    responsive: true,
    maintainAspectRatio: false, // Allows chart to resize better
    plugins: {
      legend: {
        display: false, // Hide the legend since labels will be on the chart
      },
      datalabels: {
        color: '#000', // Text color for the labels
        formatter: (value, context) => {
          return context.chart.data.labels[context.dataIndex]
        },
        font: {
          weight: 'bold',
        },
      },
    },
  }



  return (
    <>
           <div className="roomchange-container" style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar on the left for desktop */}
      <div className="d-none d-md-block sidebar-container" style={{ width: '270px', flexShrink: 0, }}>
        <Sidebar />
      </div>

      {/* Main content on the right */}
      <div className="main-content flex-grow-1" style={{ flex: 1, backgroundColor: '#f8f9fa'}}>
        <NavLogo />
             
                   <div className="d-block d-md-none">
                     <MobileNavbarAdmin />
                   </div>
        <div className="w-100 h-100 py-3 px-md-3" style={{backgroundColor:"#f5f5f5ff",}}>
          <div className="row m-0 block-header ps-3">
            <h5 className="room-change-title text-start mt-md-4 mt-2" style={{ color: '#0783d6' }}>
              Dashboard
            </h5>
          </div>

    {(adminFlag == 1 || adminFlag == 2 || adminFlag == 3) && (

      <>
        <div className="row mx-1">
          <div className="col-12 col-md-4 p-2 ">
            <div
              className="p-2 rounded"
              style={{
                backgroundColor: '#fff',
                border: 'none',
                color: '#2bdbd1',
                height:"120px",
                borderBottom: '5px solid green',
              }}
            >
              <div className="row p-0 m-0">
                <div className="col-12 d-flex fs-5 pt-2">
                  <FaUserLarge style={{ color: 'gray' }} />
                  &nbsp;&nbsp;&nbsp;
                  <h5>Students Admitted</h5>
                </div>
                <div
                  className="col-12 ps-5 "
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <p className="fs-5" style={{ color: 'gray' }}>
                    {dashboardData ? dashboardData.admitStudentCount : '-'}
                  </p>
                  {/* <p className="text-end">
                    <FaUserLarge style={{ color: 'green' }} className=" fs-3" />
                  </p> */}
                   <Button>
                      <Link to="/BlockWiseStudent" className="navigateLink">
                        <Button
                          style={{
                            backgroundColor: '#008000',
                            color: 'white',
                          }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4 p-2 ">
            <div
              className="p-2 rounded"
              style={{
                backgroundColor: '#fff',
                border: 'none',
                height:"120px",
                color: '#2bdbd1',
                borderBottom: '5px solid orange',
              }}
            >
              <div className="row p-0 m-0">
                <div className="col-12 d-flex fs-5 pt-2">
                  <MdOutlineCurrencyRupee style={{ color: 'gray' }} />
                  &nbsp;&nbsp;&nbsp;
                  <h5>Total Amount Collected</h5>
                </div>
                <div
                  className="col-12 ps-5 "
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <p style={{ color: 'gray' }}>
                    {dashboardData
                      ? `${dashboardData.totalPaymentAmount.month} : ${dashboardData.totalPaymentAmount.amount}`
                      : '-'} ₹
                  </p>

                   <Button>
                      <Link to="/TotalFeeReport" className="navigateLink">
                        <Button
                          style={{
                            backgroundColor: '#f0b02c',
                            color: 'black',
                            marginTop:"-10px"
                          }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4 p-2 ">
            <div
              className="p-2 rounded"
              style={{
                backgroundColor: '#fff',
                border: 'none',
                height:"120px",
                color: '#2bdbd1',
                borderBottom: '5px solid rgb(221, 59, 59)',
              }}
            >
              <div className="row p-0 m-0">
                <div className="col-12 d-flex fs-5 pt-2">
                  <RiPagesLine style={{ color: 'gray' }} />
                  &nbsp;&nbsp;&nbsp;
                  <h5>Complaints Pending</h5>
                </div>
                <div
                  className="col-12 ps-5 "
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <p className="fs-5" style={{ color: 'gray' }}>
                    {dashboardData ? dashboardData.complaintpendingCount : '-'}
                  </p>
                   <Button>
                      <Link to="/complaint" className="navigateLink">
                        <Button
                          style={{
                            backgroundColor: '#dd3b3b',
                            color: 'black',
                            marginTop:"-10px"
                          }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4 p-2 ">
            <div
              className="p-2 rounded"
              style={{
                backgroundColor: '#fff',
                border: 'none',
                height:"120px",
                color: '#2bdbd1',
                borderBottom: '5px solid #2bdbd1',
              }}
            >
              <div className="row p-0 m-0">
                <div className="col-12 d-flex fs-5 pt-2">
                  <PiStudentFill style={{ color: 'gray' }} />
                  &nbsp;&nbsp;&nbsp;
                  <h5>Alumni Counts</h5>
                </div>
                <div
                  className="col-12 ps-5 "
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <p className="fs-5" style={{ color: 'gray' }}>
                    {' '}
                    {dashboardData
                      ? dashboardData.recentAluminiaddedCount
                      : '-'}
                  </p>
                  <p className="text-end">
                    <PiStudentFill
                      style={{ color: '#2bdbd1' }}
                      className=" fs-2"
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>

            <div className="col-12 col-md-4 p-2 ">
              <div
                className="p-2 rounded"
                style={{
                  backgroundColor: '#fff',
                  border: 'none',
                  height: '120px',
                  color: '#2bdbd1',
                  borderBottom: '5px solid #ff6384',
                }}
              >
                <div className="row p-0 m-0">
                  <div className="col-12 d-flex fs-5 pt-2 p-0">
                    <RiTodoFill  style={{ color: '#ff6384' }} />
                    &nbsp;&nbsp;&nbsp;
                    <h5>Task Pending</h5>
                  </div>
                  <div
                    className="col-12 ps-5 "
                    style={{ display: 'flex', justifyContent: 'space-between',color:"grey" }}
                  >

                     {adminFlag == 1
                        ? dashboardData?.totalPendingTask ?? '-'
                        : adminFlag == 2
                        ? dashboardData?.pendingTaskSuper ?? '-'
                        : adminFlag == 3
                        ? dashboardData?.pendingTaskOffice ?? '-'
                        : '-'}

                {(adminFlag == 2 || adminFlag == 3)  && (
                     <Button>
                      <Link to="/ToDoAllAdmin" className="navigateLink">
                        <Button
                          style={{
                            backgroundColor: '#ff6384',
                            color: 'white',
                          }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button>
                  )}

                  </div>
                </div>
              </div>
            </div>

        </div>

        <div className="row mx-1 mt-2">
          <div className="col">
            <div>
              <h5 style={{ color: 'maroon' }}>
                <u>Pending Approval: </u>
              </h5>
            </div>
          </div>
        </div>

        <div
          className="row mx-1 pb-2 mb-2"
          style={{ borderBottom: '2px solid maroon' }}
        >
          <div className="col-12 col-md-3 p-2 ">
            <div
              className="p-2 rounded"
              style={{
                backgroundColor: '#fff',
                border: 'none',
                height:'120px',
                color: '#2bdbd1',
                borderBottom: '5px solid rgb(247, 140, 177)',
              }}
            >
              <div className="row p-0 m-0">
                <div className="col-12 d-flex fs-5 pt-2">
                  <AiFillContainer style={{ color: 'gray' }} />
                  &nbsp;&nbsp;&nbsp;
                  <h5>Application</h5>
                </div>

                <div
                  className="col-12 ps-5 "
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div className="fs-5" style={{ color: 'gray' }}>
                    {dashboardData
                      ? dashboardData.approvalPendingCount
                          .regFormApprovalPending
                      : '-'}
                  </div>
                  <div>
                   {(adminFlag == 1 || adminFlag == 3) && (
                    <Button>
                      <Link to="/Reg50Approval" className="navigateLink">
                        <Button
                          style={{
                            backgroundColor: 'rgb(247, 140, 177)',
                            color: 'black',
                          }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button>
                   )}
                   {(adminFlag == 2) && (
                    <Button>
                      <Link to="/AppApprovalList" className="navigateLink">
                        <Button
                          style={{
                            backgroundColor: 'rgb(247, 140, 177)',
                            color: 'black',
                          }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button>
                   )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-3 p-2 ">
            <div
              className="p-2 rounded"
              style={{
                backgroundColor: '#fff',
                border: 'none',
                 height:'120px',
                color: '#2bdbd1',
                borderBottom: '5px solid rgb(57, 158, 161)',
              }}
            >
              <div className="row p-0 m-0">
                <div className="col-12 d-flex fs-5 pt-2">
                  <FaUserCircle style={{ color: 'gray' }} />
                  &nbsp;&nbsp;&nbsp;
                  <h5>Member</h5>
                </div>
                <div
                  className="ps-5 "
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div className="fs-5" style={{ color: 'gray' }}>
                    {dashboardData
                      ? dashboardData.approvalPendingCount
                          .regMemberApprovalPending
                      : '-'}
                  </div>
                  <div>
                  
                  {(adminFlag == 1 || adminFlag == 2) && (
                    <Button>
                      <Link to="/StudentView" className="navigateLink">
                        <Button
                          style={{
                            backgroundColor: 'rgb(57, 158, 161)',
                            color: 'black',
                          }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button>
                  )}

                   {(adminFlag == 3) && (
                    <Button>
                      <Link to="/MemberAppPending" className="navigateLink">
                        <Button
                          style={{
                            backgroundColor: 'rgb(57, 158, 161)',
                            color: 'black',
                          }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button>
                  )}

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-3 p-2 ">
            <div
              className="p-2 rounded"
              style={{
                backgroundColor: '#fff',
                border: 'none',
                 height:'120px',
                color: '#2bdbd1',
                borderBottom: '5px solid rgb(89, 212, 143)',
              }}
            >
              <div className="row p-0 m-0">
                <div className="col-12 d-flex fs-5 pt-2">
                  <TbCoinRupeeFilled style={{ color: 'gray' }} />
                  &nbsp;&nbsp;&nbsp;
                  <h5>Payment</h5>
                </div>
                <div
                  className="ps-5 "
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div className="fs-5" style={{ color: 'gray' }}>
                    {dashboardData
                      ? dashboardData.approvalPendingCount
                          .paymentApprovalPending
                      : '-'}
                  </div>
                  <div>
                   {(adminFlag == 1 || adminFlag == 3) && (
                    <Button>
                      <Link to="/payment" className="navigateLink">
                        <Button
                          style={{
                            backgroundColor: 'rgb(89, 212, 143)',
                            color: 'black',
                          }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button>
                   )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-3 p-2 ">
            <div
              className="p-2 rounded"
              style={{
                backgroundColor: '#fff',
                border: 'none',
                 height:'120px',
                color: '#2bdbd1',
                borderBottom: '5px solid rgb(240, 176, 44)',
              }}
            >
              <div className="row p-0 m-0">
                <div className="col-12 d-flex fs-5 pt-2">
                  <MdBedroomChild style={{ color: 'gray' }} />
                  &nbsp;&nbsp;&nbsp;
                  <h5>Job</h5>
                </div>
                <div
                  className="ps-5 "
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div className="fs-5" style={{ color: 'gray' }}>
                    {dashboardData
                      ? dashboardData.jobApprovalPendingCount
                      : '-'}
                  </div>
                  <div>
                   {(adminFlag == 1 || adminFlag == 3) && (
                    <Button>
                      <Link to="/JobApproval" className="navigateLink">
                        <Button
                          style={{
                            backgroundColor: 'rgb(240, 176, 44)',
                            color: 'black',
                          }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button>
                   )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mx-1 pb-5">
          <div className="col-12 col-md-6 p-2 ">
            <div
              className="p-2 rounded"
              style={{
                backgroundColor: '#fff',
                border: 'none',
                height: '200px',
                color: '#2bdbd1',
                borderBottom: '5px solid rgb(123, 65, 119)',
              }}
            >
              <div
                className="row p-0 m-0"
                style={{ borderBottom: '2px solid gray' }}
              >
                <div className="col-12 d-flex fs-5 pt-2">
                  <FaHourglassHalf style={{ color: 'gray' }} />
                  &nbsp;&nbsp;&nbsp;
                  <h5>Half Term Admission</h5>
                </div>
                <div
                  className="col-12 ps-5 "
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <p className="fs-5" style={{ color: 'gray' }}>
                    {dashboardData
                      ? dashboardData.termYearlyStudentCount.term
                      : '-'}
                  </p>
                  <p className="text-end">
                    <FaHourglassHalf
                      style={{ color: 'rgb(123, 65, 119)' }}
                      className=" fs-4"
                    />
                  </p>
                </div>
              </div>
              <div className="row p-0 m-0">
                <div className="col-12 d-flex fs-5 pt-2">
                  <MdHourglassFull style={{ color: 'gray' }} />
                  &nbsp;&nbsp;&nbsp;
                  <h5>Full Term Admission</h5>
                </div>
                <div
                  className="col-12 ps-5 "
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <p className="fs-5" style={{ color: 'gray' }}>
                    {dashboardData
                      ? dashboardData.termYearlyStudentCount.yearly
                      : '-'}
                  </p>
                  <p className="text-end">
                    <MdHourglassFull
                      style={{ color: 'rgb(123, 65, 119)' }}
                      className=" fs-3"
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 p-2  mb-md-1 pb-md-1">
            <div
              className="p-2 rounded"
              style={{
                backgroundColor: '#fff',
                border: 'none',
                height: '200px',
                color: '#2bdbd1',
                borderBottom: '5px solid rgb(146, 209, 83)',
              }}
            >
              <div className="row p-0 m-0 ">
                <div
                  className="col-12 d-flex fs-5 pt-2"
                  style={{ borderBottom: '1px solid gray' }}
                >
                  <MdEvent style={{ color: 'gray' }} />
                  &nbsp;&nbsp;&nbsp;
                  <h5>Events</h5>
                </div>

                <div
                  className="col-12"
                  style={{ overflowY: 'scroll', maxHeight: '148px' }}
                >
                  {error ? (
                    <div>{error}</div>
                  ) : (
                    <table className="table">
                      <thead>
                        <tr
                          className="p-0 m-0"
                          style={{ height: '10px', fontSize: '13px' }}
                        >
                          <th scope="col">Sr No</th>
                          <th scope="col">Event Date</th>
                          <th scope="col">Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        {events.map((event, index) => (
                          <tr
                            key={index}
                            style={{ height: '15px', fontSize: '13px' }}
                          >
                            <td>{index + 1}</td>
                            <td>{event.event_date}</td>
                            <td>{event.description}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>

              </div>
            </div>
          </div>

            <div className="col-12 col-md-6 p-2 mb-5 pb-5 mb-md-1 pb-md-1">
                  <div
                    className="p-2 rounded"
                    style={{
                      backgroundColor: '#fff',
                      border: 'none',
                      // height: '250px',
                      color: '#2bdbd1',
                      borderBottom: '5px solid rgb(146, 209, 83)',
                    }}
                  >
                    <div className="row p-0 m-0 ">
                      <div
                        className="col-12 d-flex fs-5 pt-2"
                        style={{ borderBottom: '1px solid gray' }}
                      >
                        <MdEvent style={{ color: 'gray' }} />
                        &nbsp;&nbsp;&nbsp;
                        <h5>Todays Mess Menu</h5>
                      </div>
                      <div
                        className="col-12"
                        style={{ overflowY: 'scroll', }}
                      >
                        <Row
                          style={{ display: 'flex', justifyContent: 'space-evenly' }}
                        >
                          <Col xs={12} md={6} className="text-center" style={{borderRight:"1px solid black"}}>
                                               <h4>Lunch</h4>
                                                 {lunchData && (
                                                     <Row className="mt-lg-3 justify-content-center">
                                                       {lunchData.labels.map((menuItem, index) => (
                                                         <Col xs={6} key={index} className="mb-2 ">
                                                           <div
                                                             className="d-flex align-items-center justify-content-center"
                                                             style={{
                                                               backgroundColor: '#ffea8bff',
                                                               padding: '6px',
                                                               borderRadius: '10px',
                                                               boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                                               color:"black",
                                                             }}
                                                           >
                                                             {/* <FaUtensils style={{ color: 'green', marginRight: '6px' }} /> */}
                                                             <span style={{ whiteSpace: 'nowrap' }}>{menuItem}</span>
                                                           </div>
                                                         </Col>
                                                       ))}
                                                     </Row>
                                                   )}                      
                                             </Col>
                         
                                             <Col xs={12} md={6} className="text-center" >
                                               <h4>Dinner</h4>
                                                 {dinnerData && (
                                                   <Row className="mt-lg-3 justify-content-center">
                                                     {dinnerData.labels.map((menuItem, index) => (
                                                       <Col xs={6} key={index} className="mb-2">
                                                         <div
                                                           className="d-flex align-items-center justify-content-center"
                                                           style={{
                                                             backgroundColor: '#aef3ffff',
                                                             padding: '6px',
                                                             borderRadius: '10px',
                                                             boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                                             color:"black",
                                                           }}
                                                         >
                                                           {/* <FaUtensils style={{ color: 'blue', marginRight: '6px' }} /> */}
                                                           <span style={{ whiteSpace: 'nowrap' }}>{menuItem}</span>
                                                         </div>
                                                       </Col>
                                                     ))}
                                                   </Row>
                                                 )}
                                             </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

        </div>
      </>
    )}

     {adminFlag == 4 &&(

      <>
        <div className='row p-0 m-0 my-2 pb-2' style={{ borderBottom: '1px solid maroon' }}>

            <div className="col-12 col-md-3 p-2 ">
              <div
                className="p-2 rounded"
                style={{
                  backgroundColor: '#fff',
                  border: 'none',
                  height: '130px',
                  color: '#2bdbd1',
                  borderBottom: '5px solid #6d4c1b',
                }}
              >
                <div className="row p-0 m-0">
                  <div className="col-12 d-flex fs-5 pt-2 p-0">
                    <FaUserLarge style={{ color: '#6d4c1b' }} />
                    &nbsp;&nbsp;&nbsp;
                    <h5>Students Admitted</h5>
                  </div>
                  <div
                    className="col-12 ps-5 "
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <p className="fs-5" style={{ color: 'gray' }}>
                      {messDashboardData ? messDashboardData.admitedStudentcount : '-'}
                    </p>
                    
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-3 p-2 ">
              <div
                className="p-2 rounded"
                style={{
                  backgroundColor: '#fff',
                  border: 'none',
                  height: '130px',
                  color: '#2bdbd1',
                  borderBottom: '5px solid blue',
                }}
              >
                <div className="row p-0 m-0">
                  <div className="col-12 d-flex fs-5 pt-2 p-0">
                    <MdFreeBreakfast  style={{ color: 'blue' }} />
                    &nbsp;&nbsp;&nbsp;
                    <h5>Today's Breakfast Request</h5>
                  </div>
                  <div
                    className="col-12 ps-5 "
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <p className="fs-5" style={{ color: 'grey' }}>
                      {messDashboardData ? messDashboardData.todaybreakfastReqCount : '-'}
                    </p>
                   {/* <Button>
                      <Link to="/RequestRec" className="navigateLink">
                        <Button
                          style={{
                            backgroundColor: 'blue',
                            color: 'white',
                          }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button> */}
                  </div>
                </div>
              </div>
            </div>

              <div className="col-12 col-md-3 p-2 ">
              <div
                className="p-2 rounded"
                style={{
                  backgroundColor: '#fff',
                  border: 'none',
                  height: '130px',
                  color: '#2bdbd1',
                  borderBottom: '5px solid #ff00ff',
                }}
              >
                <div className="row p-0 m-0">
                  <div className="col-12 d-flex fs-5 pt-2 p-0">
                    <AiFillCarryOut  style={{ color: '#ff00ff' }} />
                    &nbsp;&nbsp;&nbsp;
                    <h5>Today's Leave</h5>
                  </div>
                  <div
                    className="col-12 ps-5 "
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <p className="fs-5" style={{ color: 'gray' }}>
                      <span style={{color:"black"}}>Lunch:</span> &nbsp;{messDashboardData ? messDashboardData.todayLunchLeave : '-'}
                    </p>
                    <p className="fs-5" style={{ color: 'gray' }}>
                       <span style={{color:"black"}}>Dinner:</span> &nbsp;{messDashboardData ? messDashboardData.todayDinnerLeave : '-'}
                    </p>
                   {/* <Button>
                      <Link to="/MessLeaveApproval" className="navigateLink">
                        <Button
                          style={{
                            backgroundColor: '#ff00ff',
                            color: 'white',
                          }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button> */}
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-3 p-2'></div>

            
            <div className="row mx-1 mt-2">
                <div className="col">
                  <div>
                    <h5 style={{ color: 'maroon' }}>
                      <u>Pending Approval : </u>
                    </h5>
                  </div>
                </div>
              </div>

            <div className="col-12 col-md-3 p-2 ">
              <div
                className="p-2 rounded"
                style={{
                  backgroundColor: '#fff',
                  border: 'none',
                  height: '130px',
                  color: '#2bdbd1',
                  borderBottom: '5px solid #ff9719',
                }}
              >
                <div className="row p-0 m-0">
                  <div className="col-12 d-flex fs-5 pt-2 p-0">
                    <MdOutlinePendingActions  style={{ color: '#ff9719' }} />
                    &nbsp;&nbsp;&nbsp;
                    <h5>Leave Approval Pending</h5>
                  </div>
                  <div
                    className="col-12 ps-5 "
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <p className="fs-5" style={{ color: 'grey' }}>
                      {messDashboardData ? messDashboardData.pendingLeaveCount : '-'}
                    </p>
                     <Button>
                      <Link to="/MessLeaveApproval" className="navigateLink">
                        <Button
                          style={{
                            backgroundColor: '#ff9719',
                            color: 'black',
                          }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-3 p-2 ">
              <div
                className="p-2 rounded"
                style={{
                  backgroundColor: '#fff',
                  border: 'none',
                  height: '130px',
                  color: '#2bdbd1',
                  borderBottom: '5px solid #ff6384',
                }}
              >
                <div className="row p-0 m-0">
                  <div className="col-12 d-flex fs-5 pt-2 p-0">
                    <RiTodoFill  style={{ color: '#ff6384' }} />
                    &nbsp;&nbsp;&nbsp;
                    <h5>Task Pending</h5>
                  </div>
                  <div
                    className="col-12 ps-5 "
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <p className="fs-5" style={{ color: 'grey' }}>
                      {messDashboardData ? messDashboardData.pendingAdminTodo : '-'}
                    </p>
                     <Button>
                      <Link to="/ToDoAllAdmin" className="navigateLink">
                        <Button
                          style={{
                            backgroundColor: '#ff6384',
                            color: 'white',
                          }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button>
                  </div>
                </div>
              </div>
            </div>

              <div className="col-12 col-md-3 p-2 ">
              <div
                className="p-2 rounded"
                style={{
                  backgroundColor: '#fff',
                  border: 'none',
                  height: '130px',
                  color: '#2bdbd1',
                  borderBottom: '5px solid red',
                }}
              >
                <div className="row p-0 m-0">
                  <div className="col-12 d-flex fs-5 pt-2 p-0">
                    <MdFreeBreakfast  style={{ color: 'red' }} />
                    &nbsp;&nbsp;&nbsp;
                    <h5>Breakfast Request Pending</h5>
                  </div>
                  <div
                    className="col-12 ps-5 "
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <p className="fs-5" style={{ color: 'grey' }}>
                      {messDashboardData ? messDashboardData.pendingbreakfastReqCount : '-'}
                    </p>
                     <Button>
                      <Link to="/RequestRec" className="navigateLink">
                        <Button
                          style={{
                            backgroundColor: 'red',
                            color: 'white',
                          }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button>
                  </div>
                </div>
              </div>
            </div>

             <div className="col-12 col-md-3 p-2 ">
              <div
                className="p-2 rounded"
                style={{
                  backgroundColor: '#fff',
                  border: 'none',
                  height: '130px',
                  color: '#2bdbd1',
                  borderBottom: '5px solid green',
                }}
              >
                <div className="row p-0 m-0">
                  <div className="col-12 d-flex fs-5 pt-2 p-0">
                    <AiFillAppstore  style={{ color: 'gray' }} />
                    &nbsp;&nbsp;&nbsp;
                    <h5>Complaints Action Pending</h5>
                  </div>
                  <div
                    className="col-12 ps-5 "
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <p className="fs-5" style={{ color: 'gray' }}>
                      {messDashboardData ? messDashboardData.messcomplaintPending : '-'}
                    </p>
                   <Button>
                      <Link to="/complaint" className="navigateLink">
                        <Button
                          style={{
                            backgroundColor: 'green',
                            color: 'white',
                          }}
                        >
                          View
                        </Button>
                      </Link>
                    </Button>
                  </div>
                </div>
              </div>
            </div>

        </div>

          <div className='row p-0 m-0 my-1'>
              <div className="col-12 col-md-6 p-2 mb-5 pb-5 mb-md-1 pb-md-1">
                <div
                  className="p-2 rounded"
                  style={{
                    backgroundColor: '#fff',
                    border: 'none',
                     height: '250px',
                    color: '#2bdbd1',
                    borderBottom: '5px solid rgb(146, 209, 83)',
                  }}
                >
                  <div className="row p-0 m-0 ">
                    <div
                      className="col-12 d-flex fs-5 pt-2"
                      style={{ borderBottom: '1px solid gray' }}
                    >
                      <MdEvent style={{ color: 'gray' }} />
                      &nbsp;&nbsp;&nbsp;
                      <h5>Events</h5>
                    </div>
                    <div
                      className="col-12"
                      style={{ overflowY: 'scroll', maxHeight: '148px' }}
                    >
                      {error1 ? (
                        <div>{error1}</div>
                      ) : (
                        <table className="table">
                          <thead>
                            <tr
                              className="p-0 m-0"
                              style={{ height: '10px', fontSize: '13px' }}
                            >
                              <th scope="col">Sr No</th>
                              <th scope="col">Event Date</th>
                              <th scope="col">Description</th>
                            </tr>
                          </thead>
                          <tbody>
                            {events.map((event, index) => (
                              <tr
                                key={index}
                                style={{ height: '15px', fontSize: '13px' }}
                              >
                                <td>{index + 1}</td>
                                <td>{event.event_date}</td>
                                <td>{event.description}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                </div>
              </div>

                 <div className="col-12 col-md-6 p-2 mb-5 pb-5 mb-md-1 pb-md-1">
                  <div
                    className="p-2 rounded"
                    style={{
                      backgroundColor: '#fff',
                      border: 'none',
                      // height: '250px',
                      color: '#2bdbd1',
                      borderBottom: '5px solid rgb(146, 209, 83)',
                    }}
                  >
                    <div className="row p-0 m-0 ">
                      <div
                        className="col-12 d-flex fs-5 pt-2"
                        style={{ borderBottom: '1px solid gray' }}
                      >
                        <MdEvent style={{ color: 'gray' }} />
                        &nbsp;&nbsp;&nbsp;
                        <h5>Todays Mess Menu</h5>
                      </div>
                      <div
                        className="col-12"
                        style={{ overflowY: 'scroll', }}
                      >
                        <Row
                          style={{ display: 'flex', justifyContent: 'space-evenly' }}
                        >
                          <Col xs={12} md={6} className="text-center" style={{borderRight:"1px solid black"}}>
                                               <h4>Lunch</h4>
                                                 {lunchData && (
                                                     <Row className="mt-3 justify-content-center">
                                                       {lunchData.labels.map((menuItem, index) => (
                                                         <Col xs={6} key={index} className="mb-2">
                                                           <div
                                                             className="d-flex align-items-center justify-content-center"
                                                             style={{
                                                               backgroundColor: '#ffea8bff',
                                                               padding: '6px',
                                                               borderRadius: '10px',
                                                               boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                                               color:"black",
                                                             }}
                                                           >
                                                             {/* <FaUtensils style={{ color: 'green', marginRight: '6px' }} /> */}
                                                             <span style={{ whiteSpace: 'nowrap' }}>{menuItem}</span>
                                                           </div>
                                                         </Col>
                                                       ))}
                                                     </Row>
                                                   )}                      
                                             </Col>
                         
                                             <Col xs={12} md={6} className="text-center" >
                                               <h4>Dinner</h4>
                                                 {dinnerData && (
                                                   <Row className="mt-3 justify-content-center">
                                                     {dinnerData.labels.map((menuItem, index) => (
                                                       <Col xs={6} key={index} className="mb-2">
                                                         <div
                                                           className="d-flex align-items-center justify-content-center"
                                                           style={{
                                                             backgroundColor: '#aef3ffff',
                                                             padding: '6px',
                                                             borderRadius: '10px',
                                                             boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                                                             color:"black",
                                                           }}
                                                         >
                                                           {/* <FaUtensils style={{ color: 'blue', marginRight: '6px' }} /> */}
                                                           <span style={{ whiteSpace: 'nowrap' }}>{menuItem}</span>
                                                         </div>
                                                       </Col>
                                                     ))}
                                                   </Row>
                                                 )}
                                             </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

          </div>

       </>

     )}

      </div>
      </div>
      </div>
    </>
  )
}

export default HomeAdmin
